<div class="location-padding-1" id="div_location-padding-1_ba4d4f7d"></div>
<form [formGroup]="form" id="form_cbc5a006">
  <label class="label" for="multiSelect" id="label_label_c8558a67"
    >Country</label
  >
  <p-multiSelect
    id="multiSelect"
    [options]="options"
    [(ngModel)]="selectedCountries"
    optionLabel="name"
    [placeholder]="'All'"
    (onChange)="selectCountry($event)"
    [ngModelOptions]="{ standalone: true }"
    [styleClass]="'trm-filter-location'"
    [showHeader]="false"
  ></p-multiSelect>
  <div class="location-padding-2" id="div_location-padding-2_629cbb56"></div>
  <label class="label" for="multiSelect" id="label_label_7996c2fb"
    >State/Province</label
  >
  <p-multiSelect
    id="multiSelect"
    [options]="stateOptions"
    [(ngModel)]="selectedStates"
    optionLabel="name"
    [placeholder]="'All'"
    (onChange)="selectState()"
    [ngModelOptions]="{ standalone: true }"
    [styleClass]="'trm-filter-location'"
    [showHeader]="false"
  ></p-multiSelect>
</form>
